var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.statusBox},[_c('Icon',{class:_vm.$style[_vm.status],attrs:{"name":"check-circle","type":"solid"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }